import UI from "./components/UI";
import { useDispatch } from 'react-redux'
import { setUser } from "./store/slice/userSlice";
import { useEffect, useState } from 'react'
import { check } from './http/usersAPI'

const App = () => {
  const dispatch = useDispatch()
  const [isAuthChecking, setIsAuthChecking] = useState(true)

  useEffect(() => {
    check()
      .then(data => {
        if (data) {
          dispatch(setUser(data))
        }
      })
      .catch(() => {
        localStorage.removeItem('token')
      })
      .finally(() => {
        setIsAuthChecking(false)
      })
  }, [dispatch])

  if (isAuthChecking) {
    return null
  }

  return (
    <>
      <UI />
    </>
  );


}

export default App;
